import React, { useState, useEffect, useCallback } from 'react'
import { Button, Col, Divider, Dropdown, Image, Row, Space, Table, Tooltip, Typography, Tag } from 'antd'
import { DeleteOutlined, EditOutlined, MoreOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { useAuthContext } from 'contexts/Auth'
import { useNavigate } from 'react-router-dom'
import axios from 'axios';
import ExpandedData from './ExpandedData'

const { Title } = Typography

const All = () => {

  const { user, getApiConfig } = useAuthContext()
  const [documents, setDocuments] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [status] = useState("active")
  const navigate = useNavigate()
  // console.log("documents", documents);

  const readDocuments = useCallback(async () => {
    setIsLoading(true)
    axios.get(`${window.api}/blog/all/${status}`, getApiConfig())
      .then((res) => {
        const { data, status } = res
        if (status === 200) {
          const array = data.blogs.map(blog => ({ ...blog, key: blog.uid }))
          setDocuments(array)
        }
      })
      .catch(error => {
        console.error(error)
        window.toastify(error.response?.data?.message || "Something went wrong while getting the blogs", "error")
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [getApiConfig, status])
  useEffect(() => { readDocuments() }, [readDocuments])

  const handleDelete = (row) => {
    // Optional: Confirm before delete
    if (!window.confirm("Are you sure you want to delete this blog post?")) return;

    axios
      .delete(`${window.api}/blog/delete/${row.id}`, getApiConfig())
      .then((res) => {
        const { data, status } = res;
        if (status === 200) {
          window.toastify(data.message, "success");

          // Remove deleted item from the local state
          setDocuments((prev) => prev.filter((item) => item.id !== row.id));
        }
      })
      .catch((error) => {
        console.error("Delete Blog Error:", error);
        window.toastify(
          error.response?.data?.message || "Something went wrong while deleting the blog",
          "error"
        );
      });
  };

  const columns = [
    {
      title: 'Poster Image', align: "center",
      render: (item, row) => <Image src={row.imageURL} alt="" className="rounded" style={{ width: 48, height: 48 }} />,
    },
    {
      title: 'Banner Image', align: "center",
      render: (item, row) => <Image src={row.bannerURL} alt="" className="rounded" style={{ width: 80, height: 48 }} />,
    },
    { title: 'Title', dataIndex: 'title', align: "center", },
    { title: 'Slug', dataIndex: 'slug', align: "center", },
    { title: 'ID', dataIndex: 'id', align: "center", },
    { title: 'Author', dataIndex: 'author', align: "center", },
    { title: 'Description', dataIndex: 'description', align: "center", },
    {
      title: 'Status', dataIndex: 'status', align: "center", className: 'text-capitalize',
      render: (_, row) => <Tag color={window.getTagColor(row.status)}>{row.status}</Tag>,
    },
    { title: 'Sort Order', dataIndex: 'sortOrder', align: "center", },
    {
      title: 'Action', align: "center",
      render: (_, row) => (
        <Dropdown
          menu={{
            items: [
              { label: "Edit", icon: <EditOutlined />, onClick: () => { navigate(`/dashboard/blogs/${row.id}`) } },
              { label: "Delete", icon: <DeleteOutlined />, onClick: () => { handleDelete(row) } },
            ]
          }}
          trigger={['click']}
        >
          <MoreOutlined className='text-primary' />
        </Dropdown>
      ),
    },
  ]

  return (
    <>
      <Row className='mb-3'>
        <Col>
          <Title level={3} className="mb-0">Blogs</Title>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="card">
            <Row>
              <Col span={24} className="d-flex justify-content-end align-items-center">
                <Space size="small">
                  <Tooltip title="Refresh Blogs"><Button icon={<ReloadOutlined />} onClick={readDocuments} /></Tooltip>
                  <Tooltip title="Add Blog"><Button type='primary' icon={<PlusOutlined />} onClick={() => { navigate("/dashboard/blogs/add") }} /></Tooltip>
                </Space>
              </Col>
            </Row>

            <Divider />

            <Table
              columns={columns.filter((item) => !item.allowedroles || user.roles?.find(role => item.allowedroles?.includes(role)))}
              dataSource={documents}
              rowKey={record => record._id || record.id} // <-- unique key from MongoDB or ID
              loading={isLoading}
              scroll={{ x: true }}
              size="small"
              expandable={{ expandedRowRender: (row) => <ExpandedData data={row} /> }}
            />
          </div>
        </Col>
      </Row>
    </>
  )
}

export default All